import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { AssignmentModel } from "../Assignments Model/assignment-data.model";

export class AssignmentNotAcceptedGridModel extends AssignmentModel { }

export class AssignementNotAcceptingListingModel extends GridModel<AssignmentNotAcceptedGridModel> { }

export class AssignmentNotAcceptingGridParams extends GridPostParams {
    pageNumber: any = 1;
    pageSize: any = 10;
    id: any = 338;
    sortBy:string = 'accepted'
  }